module.exports = __webpack_public_path__ + "h5/img/live-logo.d799d993.gif";